import {inject, observer} from "mobx-react";
import * as React from "react";
import LazyLoad from "react-lazyload";
import {Link} from "react-router-dom";
import masterCardIcon from '../../assets/icons/makseKeskus/Mastercard.png';
import visaIcon from '../../assets/icons/makseKeskus/Visa.png';
import footerBrandPng from '../../assets/imgs/FooterBrand.png';
import footerBrandWebp from '../../assets/imgs/FooterBrand.webp';
import Base, {IBaseProps} from "../base";
import './footer.css';

@inject('rootStore')
@observer
export default class Footer extends Base<IBaseProps> {
    public render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const rootStore = this.rootStore;
        const sysInfo = rootStore.sysInfo;
        const ordersAllowed = this.isOrdersAllowed();

        return <footer className="footer-distributed">
            <div className="footer-left">
                <div className="col-4 offset-4 col-md-3 offset-md-0 p-0 footer-brand">
                    <LazyLoad>
                        <picture>
                            <source srcSet={footerBrandWebp} type="image/webp"/>
                            <source srcSet={footerBrandPng} type="image/png"/>
                            <img src={footerBrandPng} alt="Footer brand"/>
                        </picture>
                    </LazyLoad>
                </div>
                <br/>
                {sysInfo.company && <p>{sysInfo.company}</p>}
                {sysInfo.regCode && <p>{this.translate("footer.reg-code", "Reg. code")}: {sysInfo.regCode}</p>}
                <br/>
                {ordersAllowed && <div>
                    <p>{this.translate("footer.payment-methods", "Payment methods")}: <span
                        className="footer-mastercard"><img className="img-fluid" src={masterCardIcon} alt="Mastercard"/></span>/<span
                        className="footer-visa"><img className="img-fluid" src={visaIcon} alt="Visa"/></span></p>
                    <Link to="/terms"
                          target="_blank">{this.translate("footer.terms", "Terms and conditions")} </Link> / <Link
                    to="/privacy" target="_blank">{this.translate("footer.privacy", "Privacy policy")}</Link>
                    <br/><br/><br/>
                </div>}
                {sysInfo.name && <p className="footer-company-name">{sysInfo.name} &copy; 2020</p>}
            </div>
            <div className="footer-center text-left">
                {sysInfo.address && <div>
                    <a href="#">
                        <i className="fa fa-map-marker"/><span>{sysInfo.address}</span>
                    </a>
                </div>}
                {sysInfo.phone && <div>
                    <a href={`tel:${sysInfo.phone}`}>
                        <i className="fa fa-phone"/><span>{sysInfo.phone}</span>
                    </a>
                </div>}
                {sysInfo.email && <div>
                    <a href={`mailto:${sysInfo.email}`}>
                        <i className="fa fa-envelope"/><span>{sysInfo.email}</span>
                    </a>
                </div>}
            </div>
            <div className="footer-right">
                <p className="footer-company-about">
                    <span>{this.translate("footer.about", "About")}</span>
                    Meekoja mesinikutarkusi on põlvest põlve edasi antud. Tänu kogutud teadmistele, oskustele ja pühendumisele on Meekoja mesi saanud paljude lemmikuks.
                </p>
                <div className="footer-icons">
                    {sysInfo.facebook &&
                    <a rel="noopener" href={`//www.facebook.com/${sysInfo.facebook}`} target="_blank"><i
                        className="fa fa-facebook"/></a>}
                    {sysInfo.instagram &&
                    <a rel="noopener" href={`//www.instagram.com/${sysInfo.instagram}`} target="_blank"><i
                        className="fa fa-instagram"/></a>}
                </div>
            </div>
        </footer>;
    }
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.tsx